/**
 * Builders for the social share links used by the share modals.
 *
 * Two things matter here:
 *  - the shared item's name goes into the message, so the recipient sees what
 *    the link is about even before the crawler preview loads;
 *  - every value is URL-encoded. Interpolating a raw URL (or Arabic text) into
 *    a query string truncates it at the first "&" or breaks the link entirely.
 */

const SITE_NAME = "جمعية تكافل لرعاية الأيتام";

/** "اسم المشروع | جمعية تكافل لرعاية الأيتام" -- or just the site name. */
export const buildShareMessage = (title?: string) =>
  title?.trim() ? `${title.trim()} | ${SITE_NAME}` : SITE_NAME;

export const shareLinks = (url: string = "", title?: string) => {
  const message = buildShareMessage(title);
  const encodedUrl = encodeURIComponent(url);
  const encodedMessage = encodeURIComponent(message);

  return {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(
      `${message}\n${url}`
    )}`,
    x: `https://x.com/intent/tweet?text=${encodedMessage}&url=${encodedUrl}`,
    instagram: `https://www.instagram.com/direct/new/?text=${encodeURIComponent(
      `${message} ${url}`
    )}`,
  };
};
